module.exports = __webpack_public_path__ + "static/media/negative-coin-icon.ec8573e8.svg";